import { PropsWithChildren, FC } from 'react'
import jobDetailsStyles from '@ProdWb/JobDetails/styles.css'

import Text from '~/core/Text'

type FollowersStaticTextPropsType = {
    assignedDri: boolean
    isChannel: boolean
}

const FollowersStaticText: FC<
    PropsWithChildren<FollowersStaticTextPropsType>
> = props => {
    const { assignedDri, isChannel } = props

    if (assignedDri) {
        return <Text className={jobDetailsStyles.soName}>Assigned MFG-DRI</Text>
    } else if (isChannel) {
        return <Text className={jobDetailsStyles.soName}>Channel</Text>
    } else {
        return <Text className={jobDetailsStyles.soName}>MP contact</Text>
    }
}

export default FollowersStaticText
